<template>
  <div style="width: 100%; height: 100%; padding-left: 252px">
    <v-card style="height: 100%" elevation="0">
      <v-card-title>
        应用角色<v-spacer />
        <v-btn color="green" elevation="0" dark @click="add"> <v-icon dark>mdi-plus</v-icon>新增 </v-btn>
      </v-card-title>
      <v-toolbar flat>
        <v-btn-toggle v-model="btnValue" @change="btnGroupClick" dense group mandatory color="primary" class="ml-n2">
          <v-btn :value="bi.key" class="ml-2" v-for="(bi, index) in btnGroup" :key="index">{{ bi.val }}</v-btn>
        </v-btn-toggle>
        <v-spacer></v-spacer>
        <div style="width: 300px">
          <v-text-field @keyup.enter="searchQuery" @click:append="searchQuery" v-model="queryParam.condition" placeholder="名称/描述" class="pt-5" append-icon="mdi-magnify" outlined dense clearable></v-text-field>
        </div>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text class="pt-0">
        <v-data-table :headers="headers" :items="desserts" disable-pagination :loading="loading" loading-text="数据加载中..." class="elevation-0" hide-default-footer>
          <template v-slot:[`item.first_col`]="{ item }">{{ desserts.indexOf(item) + 1 }}</template>
          <template v-slot:[`item.leve`]="{ item }">{{ item.leve | dict("0:国家/2:省级/4:市级/6:区县/9:街镇/12:村社") }}</template>
          <template v-slot:[`item.operator`]="{ item }">{{ item.operator }}</template>
          <template v-slot:[`item.operateTime`]="{ item }">{{ item.operateTime | date("yyyy-MM-dd HH:mm:ss") }}</template>
          <template v-slot:[`item.actions`]="{ item }">
            <a class="primary--text mr-4" @click="edit(item)">授权</a>
            <a class="red--text mr-0" @click="deleteItem(item.id, '删除后将无法恢复，请谨慎删除！！！')">删除</a>
          </template>
          <template v-slot:[`item.note`]="{ item }">
            {{ item.note | txt(24) }}
          </template>
        </v-data-table>
        <pagination class="float-right mr-2 mt-2" :page-sizes="[10, 20]" :page-data="pageData" @pageChange="getListPage" />
      </v-card-text>
    </v-card>
    <apps-roles-input ref="appsForm" @ok="modalFormOk" />
  </div>
</template>
<script>
import PageMixins from "@/compositions/mixins/pagination";
import Pagination from "@/components/pagination";
import AppsRolesInput from "./apps-roles-input";
export default {
  mixins: [PageMixins],
  components: { Pagination, AppsRolesInput },
  data: () => ({
    url: { list: "rbac/role/page", delete: "rbac/role/delete" },
    headers: [
      { text: "序号", value: "first_col", sortable: false, width: 60 },
      { text: "角色名称", value: "name", sortable: false },
      { text: "角色代码", value: "code", sortable: false },
      { text: "角色等级", value: "leve", sortable: false },
      { text: "角色描述", value: "note", sortable: false },
      { text: "创建人员", value: "operator", sortable: false, width: 130 },
      { text: "创建时间", value: "operateTime", sortable: false, width: 220 },
      { text: "操作", value: "actions", sortable: false, width: 120 },
    ],
    btnGroup: [
      { key: "0", val: "全部" },
      { key: "2", val: "省级" },
      { key: "4", val: "市级" },
      { key: "6", val: "区县" },
      { key: "9", val: "街镇" },
      { key: "12", val: "村社" },
    ],
    btnValue: "0",
  }),
  mounted() {
    this.roleQuery();
  },
  watch: {
    $route(to, from) {
      to.query.aid && to.query.aid != from.query.aid && this.roleQuery();
    },
  },
  methods: {
    roleQuery() {
      this.queryParam.aid = this.$route.query.aid;
      this.searchQuery();
    },
    btnGroupClick() {
      this.queryParam.leve = this.btnValue;
      this.searchQuery();
    },
    add() {
      this.$refs.appsForm.add();
    },
    edit(item) {
      this.$refs.appsForm.edit(item);
    },
  },
};
</script>